import { gql } from '@apollo/client';

export const UPDATE_FILE = gql`
  mutation UpdateFile($organizationFile: OrganizationFileUpdateInput!, $fileId: Int!) {
    updateOrganizationFile(organizationFile: $organizationFile, file_id: $fileId) {
      file_id
    }
  }
`;
